/* eslint-disable react/jsx-key */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import Actions_Wind from '~/Actions_Wind';
import excel from '~/skills/excel';
import { S_Btn_Search, S_Select, S_Title } from '~/components/SearchItem';
import { T_TableRow, T_TitleCell } from '~/components/TableItem';
import PageTitle from '~/components/PageTitle';
import ExportButton from '~/components/Button/ExportButton';
import SearchBar from '~/components/SearchBar';

const RenderTableTitle = () => {
  const list = useSelector(state => state.data.FanStore || []);
  const ary = [];
  if (list[0]) {
    for (const name of Object.keys(list[0])) {
      if (name !== 'proj_item')ary.push({ name });
    }
  }
  return (
    <TableHead>
      <TableRow style={{ height: 48 }}>
        <T_TitleCell rowSpan={2} color='#247691' text='項目' />
        <T_TitleCell colSpan={5} text='貯放地點' />
      </TableRow>
      <TableRow style={{ height: 48 }}>
        {ary.map((o, i) => (
          <T_TitleCell
            key={i}
            text={o.name}
            color='#247691'
          />
        ))}
      </TableRow>
    </TableHead>
  );
};

const RenderTableBody = () => {
  const list = useSelector(state => state.data.FanStore || []);
  const cellStyle = { fontSize: 14 };
  const labelAry = [];
  if (list[0]) {
    for (const name of Object.keys(list[0])) {
      if (name !== 'proj_item')labelAry.push(name);
    }
  }
  return (
    <TableBody>
      {list.map((o, i) => (
        <T_TableRow key={i}>
          <TableCell align='center' style={{ color: '#247691', ...cellStyle }}>{o.proj_item}</TableCell>
          {labelAry.map((o2, i2) => (<TableCell key={i2} align='center' style={cellStyle}>{o[o2]}</TableCell>))}
        </T_TableRow>
      ))}
    </TableBody>
  );
};

const RenderTable = () => {
  const list = useSelector(state => state.data.FanStore || []);
  const haveData = list.length > 0;
  return (
    <TableContainer>
      <Table style={{ backgroundColor: 'white', borderRadius: 8 }}>
        <RenderTableTitle />
        {haveData && <RenderTableBody />}
      </Table>
    </TableContainer>
  );
};

const App = props => {
  const [data, setData] = useState({ windId: '' });
  const { windId } = data;
  const dispatch = useDispatch();
  const SwitchProjectList = useSelector(state => state.data.SwitchProjectList || []);
  const list = useSelector(state => state.data.FanStore || []);
  const haveData = list.length > 0;
  const onClickSearch = () => Actions_Wind.Gis.getFanStore(dispatch, { id: windId });
  const onExport = () => {
    if (!haveData)alert('無匯出資料');
    else {
      let name = '';
      SwitchProjectList.forEach(o => {
        if (o.value === windId)name = o.name;
      });

      const ary1 = [];
      Object.keys(list[0]).forEach(o => { if (o !== 'proj_item')ary1.push(o); });

      excel.outputAryAry({
        header: ['項目', '貯放地點'],
        data: [
          ['', ...ary1],
          ...list.map(o => [o.proj_item, ...ary1.map(o2 => o[o2])]),
        ],
        fileName: `風機部件儲放情形_${name}`,
      });
    }
  };
  useEffect(() => () => Actions_Wind.clearKey(dispatch, { key: 'FanStore' }), []);
  return (
    <div style={{
      position: 'absolute',
      left: 13,
      right: 0,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      overflow: 'auto',
    }}
    >
      <PageTitle text='風機部件儲放情形' />

      <div style={{ width: '100%', display: 'flex', flexDirection: 'row-reverse' }}>
        <ExportButton style={{ marginRight: 28 }} onClick={onExport} />
      </div>
      <SearchBar style={{ marginTop: 16, marginBottom: 25 }} text='部件儲放' defaultOpen>
        <div style={{ display: 'flex' }}>
          <div>
            <S_Title text='風場' />
            <S_Select list={SwitchProjectList} value={windId} onChange={t => setData({ ...data, windId: t })} />
          </div>
          <div style={{ marginLeft: 16, display: 'flex', flexDirection: 'column-reverse' }}>
            <S_Btn_Search onClick={onClickSearch} />
          </div>
        </div>
        <div style={{ marginLeft: 52, marginRight: 52, marginTop: 20, marginBottom: 20 }}>
          <div style={{ borderRadius: 8, boxShadow: '0px 4px 13px rgba(24, 98, 121, 0.4)' }}>
            {haveData && <RenderTable />}
            {/* {haveData && this.renderTableBar()} */}
          </div>
          {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
        </div>
      </SearchBar>
    </div>
  );
};

export default App;
